"use strict";

var _taggedTemplateLiteral = require("/home/circleci/project/story/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageWrapper = exports.Image = exports.Container = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _highsnobiety = require("@titelmedia/bricks-theme/lib/variables/highsnobiety");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Container = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n"])));

exports.Container = Container;

var ImageWrapper = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  max-height: calc(100vh - ", ");\n  overflow: hidden;\n  position: sticky;\n  top: 0;\n\n  @media (max-width: 1023px) {\n    position: inherit;\n    padding: 0px 16px;\n\n    img {\n      margin-top: 10px;\n    }\n  }\n"])), _highsnobiety.HEADER_HEIGHT.DESKTOP);

exports.ImageWrapper = ImageWrapper;

var Image = _styledComponents.default.img(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  object-fit: cover;\n  min-height: 100%;\n  min-width: 100%;\n"])));

exports.Image = Image;